import React from 'react';
import { Container, WhiteFooter } from './styles';
import Duplicates from './Duplicates';
import { Tab } from '@gerdau/hefesto/Tab';

const FinancialsTabs = () => {
  return (
    <Container>
      <Tab
        activeKey="Duplicatas"
        tabItems={[
          {
            key: 'Duplicatas',
            name: 'Duplicatas',
            content: <Duplicates />
          }
        ]}
      />
      <WhiteFooter />
    </Container>
  );
};

export default FinancialsTabs;
